var React = require('react');

function IconFlag (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M15.3 6.824l.56 2.824h7.34v8.471h-4.7l-.56-2.824H7.8V6.824h7.5M17.6 4H5v24h2.8v-9.882h7.84l.56 2.824H26V6.824h-7.84z","transform":"translate(-5 -4)"}));
}

IconFlag.defaultProps = {"width":"21","height":"24","viewBox":"0 0 21 24"};

module.exports = IconFlag;

IconFlag.default = IconFlag;
